/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {renderMoney} from '../../utils';

import '../../styles/channel/ChannelPayPanel.css';

const ChannelMonthRecord = ({priceItem, clickHandle}) => (
    <div className="weui-actionsheet__cell weui-padding" data-id={priceItem.id} data-money={priceItem.money} onClick={clickHandle}>
        <p className="weui-flex">
            <span className="weui-flex__item text-left flex_3">
                <i className={"iconfont icon-zhengque " + (priceItem.selected ? "month-selected" : "month-no-selected")}/>
                <span className="padding-left">{priceItem.month}个月专栏会员</span>
            </span>
            <span className="weui-flex__item text-right flex_1">
                <span className="money">￥{renderMoney(priceItem.money)}</span>
            </span>
        </p>
    </div>
);

class ChannelMonthPanel extends Component {
    constructor() {
        super();
        this.handleMonthSelect = this.handleMonthSelect.bind(this);
    }

    handleMonthSelect(e) {
        this.props.dispatch({
            type: 'CHANNEL_SELECT_MONTH_PAY',
            payload: {
                priceRecordId: e.currentTarget.dataset.id,
                priceRecordMoney: e.currentTarget.dataset.money,
            }
        });
    }

    render() {
        const {priceList} = this.props;
        return (
            <div className="channel-month-panel weui-actionsheet__menu">
                {priceList.map((item) => (
                    <ChannelMonthRecord key={item.id} priceItem={item} clickHandle={this.handleMonthSelect}/>
                ))}
            </div>
        )
    }
}

export default connect((state) => ({
    priceList: state.channel.channel.price_list
}))(ChannelMonthPanel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelMonthPanel.js